import { create } from "zustand";

export const useLoading = create((set) => ({
  isExperienceReady: false,
  shouldShowExperience: false,
  setExperienceReady: (ready) => set({ isExperienceReady: ready }),
  setShouldShowExperience: (show) => set({ shouldShowExperience: show }),
}));
